const portalWrappers = (state, action) => {
    if (state === undefined) {
        return false;
    }

    switch (action.type) {
        case "SET_PORTAL_WRAPPERS":
            return { ...state.portalWrappers, ...action.payload};
        default:
            return state.portalWrappers;
    }
};

export { portalWrappers };
